import Vue from 'vue';

const success = (data, resolve) => {
  resolve(data);
};

const failed = (errors, reject) => {
  reject(errors);
};

export default (subscriberId, action) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .put(`subscriberList/subscriberSwitch/${subscriberId}`, action)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/subscriber/subscribeSwitch.js